import React from 'react';
import ReactDOM from 'react-dom/client';
// Import SASS styles (includes Tailwind via @import in main.scss if needed)
import './styles/main.scss';
// Keep index.css for Tailwind directives
import './index.css';
// App-level styles
import './App.scss';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);